<template>
  <ul class="el-upload-list el-upload-list--text" style="padding-bottom:10px;display:block;">
    <li v-for="e in attachmentList" :key="e.filePath" class="el-upload-list__item is-success">
      <a class="el-upload-list__item-name" target="_blank" :href="e.filePath">
        <i class="el-icon-document"></i>{{e.fileName}}
      </a>
      <label class="el-upload-list__item-status-label">
        <i class="el-icon-upload-success el-icon-circle-check"></i>
      </label>
      <i class="el-icon-close" @click="deleteFile(e)"></i>
      <i class="el-icon-close-tip">按 delete 键可删除</i>
    </li>
  </ul>
</template>
<script>
export default {
  name: "TicketUploadList",

  props : ['ticketUpload'],

  data() {
    return {
      attachmentList : []
    };
  },

  methods : {
    deleteFile(e) {
      if ( !!this.ticketUpload ) {
        this.ticketUpload.deleteFile(e);
      }

      this.$emit("delete", e);
    },

    deleteAll() {
      this.attachmentList = [];

      this.$emit("clear", '');
    },

    setAttachmentList( _list ) {
      this.attachmentList = _list;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketUploadList.vue